export enum GroupedMedia {
  BASIC = "media",
}
